import React from 'react';

import Button from '../../library/button/button';
import Typography, { VariantProps } from '../../library/typography/typography';
import { TagsSolidIcon } from '../../shared/icons/icons';

import './product-instant-promo-message.scss';

interface ProductInstantPromoMessageProps {
  instantStrikethroughSavingsPerProduct?: number;
  showLearnMore?: boolean;
  showShortDescription?: boolean;
  textVariant?: VariantProps;
  totalStrikethroughSavings?: number;
}

function ProductInstantPromoMessage(props: ProductInstantPromoMessageProps) {
  const {
    instantStrikethroughSavingsPerProduct,
    showLearnMore = false,
    showShortDescription = false,
    textVariant = 'P',
    totalStrikethroughSavings
  } = props;

  if (!instantStrikethroughSavingsPerProduct) return null;

  return (
    <>
      {showShortDescription ? (
        <div styleName="short-description">
          <TagsSolidIcon styleName="icon" />
          <Typography
            styleName="short-description-copy"
            tag="span"
            variant={textVariant}
          >
            <b>Save ${instantStrikethroughSavingsPerProduct.toFixed(2)}</b> per
            tire
          </Typography>
        </div>
      ) : (
        <Typography styleName="description" tag="span" variant={textVariant}>
          <b>Save ${instantStrikethroughSavingsPerProduct.toFixed(2)}</b> per
          tire for a total of{' '}
          <b styleName="total-strikethrough-savings">
            ${totalStrikethroughSavings?.toFixed(2)} off
          </b>{' '}
          with purchase of a set of 4 tires.
        </Typography>
      )}
      {showLearnMore && (
        <Button href="/promotions" size="regular" target="_blank">
          learn more
        </Button>
      )}
    </>
  );
}

export default ProductInstantPromoMessage;
